// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"43":"8d3a230753230cb1","827":"3d7fb33bbdfea37d","971":"33af4a9c77cbfec9"}[chunkId] + ".js";
};